import React, { useEffect, useState } from "react";
import WishlistItem from "./WishlistItem";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Wishlist = () => {
  const navigate = useNavigate();
  const [wishlistItems, setWishlistItems] = useState([]);

  useEffect(() => {
    const localWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    setWishlistItems(localWishlist);
  }, []);

  const handleRemoveItem = (id) => {
    const updatedWishlist = wishlistItems.filter((item) => item._id !== id);
    setWishlistItems(updatedWishlist);
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
  };

  const themeColor = "rgb(85 31 61 / 1)";

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 lg:px-16">
      {wishlistItems.length > 0 ? (
        <div className="lg:grid grid-cols-3 gap-6">
          {/* Left Section */}
          <div className="lg:col-span-2 bg-white p-5 rounded-lg shadow-md">
            <h2
              className="text-2xl font-bold mb-4"
              style={{ color: themeColor }}
            >
              My Wishlist
            </h2>
            <div className="space-y-4">
              {wishlistItems.map((item) => (
                <WishlistItem
                  key={item._id}
                  item={item}
                  showButton={true}
                  onRemove={handleRemoveItem}
                  themeColor={themeColor}
                />
              ))}
            </div>
          </div>

          {/* Right Section */}
          <div className="bg-white p-5 rounded-lg shadow-md">
            <h2
              className="text-xl font-bold mb-4"
              style={{ color: themeColor }}
            >
              Wishlist Summary
            </h2>
            <div className="space-y-2 text-gray-700">
              <p>Total Items: {wishlistItems.length}</p>
              <p>
                Total Price: ₹
                {wishlistItems.reduce(
                  (sum, item) => sum + Number(item.discountedPrice || 0),
                  0
                )}
              </p>
            </div>
            <Button
              variant="contained"
              className="mt-6 w-full"
              style={{
                backgroundColor: themeColor,
                color: "#fff",
              }}
              onClick={() => navigate("/")}
            >
              Continue Shopping
            </Button>
          </div>
        </div>
      ) : (
        <div className="text-center py-20 bg-white rounded-lg shadow-md">
          <h2
            className="text-3xl font-bold mb-4"
            style={{ color: themeColor }}
          >
            Your wishlist is empty
          </h2>
          <Button
            variant="contained"
            style={{
              backgroundColor: themeColor,
              color: "#fff",
            }}
            onClick={() => navigate("/")}
          >
            Start Shopping
          </Button>
        </div>
      )}
    </div>
  );
};

export default Wishlist;
